var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  null,
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-262cab50\",\"hasScoped\":false,\"preserveWhitespace\":false}!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./shared.vue"),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/uikit/components/AppSvgIconNew/templates/icons/shared.vue
// module id = 0e64c07a2b13f917e373
// module chunks = 89